import React, { useCallback, useEffect } from "react";

import FooterDescription from "../../components/ui/FooterDescription";
import FooterLogo from "../../components/ui/FooterLogo";
import Props from "./props";
import SchoolAttachements from "../../components/School/SchoolAttachements";
import SchoolDate from "../../components/School/SchoolDate";
//import SchoolCell from "../../components/School/SchoolCell";
import SchoolRows from "../../components/School/SchoolRows";
import SchoolTitle from "../../components/School/SchoolTitle";
import SingleSchoolCategories from "../../components/School/SingleSchoolCategories";
import TablePaper from "../../components/ui/TablePaper/styled";
import ToggleSchoolEditing from "../../components/School/ToggleSchoolEditing";
import resetToggleSchoolEditingAction from "../../../state/actions/SchoolActions/resetToggleSchoolEditingAction";
import sendEditSchoolAction from "../../../state/actions/SchoolActions/sendEditSchoolAction";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import useSchool from "../../../state/hooks/SchoolHooks/useSchool";
import useSchoolsAndCategories from "../../../state/hooks/SchoolHooks/useSchoolsAndCategories";

const Single: React.FC<Props> = (props) => {
    useSchool();
    useSchoolsAndCategories();
    const dispatch = useDispatch();
    const resetToggleSchoolEditing = useCallback(() => dispatch(resetToggleSchoolEditingAction()), [dispatch]);
    useEffect(() => {
        return () => {
            resetToggleSchoolEditing();
        };
    }, [resetToggleSchoolEditing]);
    const sendEditSchool = useCallback(() => dispatch(sendEditSchoolAction()), [dispatch]);
    return (
        <Wrapper
            onSubmit={(e: React.FormEvent) => {
                e.preventDefault();
                sendEditSchool();
            }}
        >
            <ToggleSchoolEditing />
            <TablePaper>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <div className="page">
                                    <SchoolTitle />
                                    <SchoolRows />
                                    <SingleSchoolCategories />
                                    <SchoolAttachements />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>
                                <div className="page-footer-space"></div>
                            </td>
                        </tr>
                    </tfoot>
                </table>
                <FooterLogo />
                <SchoolDate />
                <FooterDescription />
            </TablePaper>
        </Wrapper>
    );
};

export default Single;

const Wrapper = styled.form`
    width: 60rem;
    margin: 0 auto;
    padding: 5rem 0;
    @media print {
        padding: 0;
        max-width: 100%;
    }
    table {
        width: 100%;
    }
    .page-footer,
    .page-footer-space {
        height: 8rem;
    }
    .page-footer {
        position: fixed;
        bottom: 0;
    }
    .page {
        page-break-after: always;
    }
`;
